<template>
  <div :class="['AnnouncementContent']">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AnnouncementContent',
}
</script>

<style lang="scss">
.AnnouncementContent {
  display: flex;
  padding: 16px 0 20px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
}
</style>
